import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaClone } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import DashleadAPI from '../../../api/DashleadAPI';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Const from '../../../util/Constants';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';
import { Badge } from 'react-bootstrap';

class DashleadList extends React.Component {

  constructor(props) {
    super(props);
    this.dashleads = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path;

    const model = reactLocalStorage.getObject(Const.Model).dashboard;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() {
    if (this.List) {
      DashleadAPI.list(this.onReceived, this.onFail);
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = dashleads => {
    this.dashleads = dashleads;
    this.setState({ ...this.state, inApiCall: false });
  };

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.dashleads[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        DashleadAPI.delete(this.dashleads[index].id, this.onDelete, this.onFail);
      });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Dashlead Deleted successfully', 'success');
    DashleadAPI.list(this.onReceived, this.onFail);
  };

  onCopy = id => {
    DashleadAPI.copy(id, this.onCopySuccess, this.onFail);
    this.setState({ ...this.state, inApiCall: true, popup: false });
  };
  onCopySuccess = () => {
    Util.showNotification('Successful', 'Copy successfully', 'success');
    DashleadAPI.list(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const dashleadUI = this.dashleads.map((dashlead, _i) => (
      <tr key={`dashlead_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{dashlead.name}</td>
        <td>{Display.ModelLabelValue('user', dashlead.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(dashlead.created_date)}</td>
        <td>{Display.ModelLabelValue('user', dashlead.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(dashlead.updated_date)}</td>
        <td>
          {this.Update ?
            <NavLink to={`${this.path}/add-edit/${dashlead.id}`} >
              <Badge variant="warning" size='sm' className='m-1 p-2 text-white' > <FaPencilAlt color='#ffffff' /> Edit</Badge>
            </NavLink>
            : null
          }
          {this.Add ?
            <Badge variant="success" size='sm' onClick={() => this.onCopy(dashlead.id)} className='m-1 p-2 text-white' > <FaClone color='#ffffff' /> Copy</Badge>
            : null
          }
          {dashlead.status !== Const.AlwaysActive && this.Delete ?
            <Badge variant="danger" size='sm' onClick={() => this.confirmDelete(_i)} className='m-1 p-2 text-white' > <FaClone color='#ffffff' /> Delete</Badge>
            : null
          }
        </td>
      </tr>
    ));

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 pb-3">
              <h3>Dashleads</h3>
            </div>
            {this.Add ?
              <div className="col-md-6 text-right pb-3">
                <span onClick={() => this.onShow(-1)} className="buttons success">+ Add</span>
              </div>
              : null
            }
            <div className="col-md-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Name</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ApiUiController inApiCall={this.props.inApiCall} >
                    {dashleadUI}
                  </ApiUiController>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(DashleadList);
